












































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Topbar from '@/components/Topbar.vue';
import Carousel from '@/components/Carousel.vue';
import SearchBar from '@/components/SearchBar.vue';
import { GoogleMapsService } from '@/services/GoogleMaps';

@Component({
  components: {
    Topbar,
    Carousel,
    SearchBar,
  },
})
export default class Home extends Vue {
  public mounted() {
    GoogleMapsService.loadGoogleApi().then(async () => {
      const test = GoogleMapsService.getPredictions('Playstation');
    });
  }
}
